export default __webpack_public_path__ + "static/media/icons8-facebook-logo.1d60f030.svg";